import React, { useState } from 'react';
import './AdminLogin.css';
import { useAuth } from '../contexts/AuthContext';

const MIN_PASSWORD_LENGTH = 6;

const ResetPassword: React.FC = () => {
    const { updatePassword, clearRecovery } = useAuth();
    const [password, setPassword] = useState('');
    const [confirm, setConfirm] = useState('');
    const [error, setError] = useState<string | null>(null);
    const [loading, setLoading] = useState(false);
    const [done, setDone] = useState(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError(null);

        if (password.length < MIN_PASSWORD_LENGTH) {
            setError(`Password must be at least ${MIN_PASSWORD_LENGTH} characters.`);
            return;
        }
        if (password !== confirm) {
            setError('Passwords do not match.');
            return;
        }

        setLoading(true);
        const errorMsg = await updatePassword(password);
        setLoading(false);
        if (errorMsg) {
            setError(errorMsg);
        } else {
            setDone(true);
        }
    };

    return (
        <div className="admin-login-backdrop" role="dialog" aria-modal="true" aria-labelledby="reset-password-title">
            <div className="admin-login-modal">
                <h2 id="reset-password-title" className="admin-login-title">Set a New Password</h2>
                {done ? (
                    <>
                        <p className="admin-login-info">Your password has been updated. You are now signed in.</p>
                        <button className="admin-login-submit" type="button" onClick={clearRecovery}>
                            Done
                        </button>
                    </>
                ) : (
                    <form onSubmit={handleSubmit} className="admin-login-form">
                        <label className="admin-login-label" htmlFor="reset-password">New password</label>
                        <input
                            id="reset-password"
                            className="admin-login-input"
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            autoComplete="new-password"
                            autoFocus
                        />
                        <label className="admin-login-label" htmlFor="reset-confirm">Confirm password</label>
                        <input
                            id="reset-confirm"
                            className="admin-login-input"
                            type="password"
                            value={confirm}
                            onChange={(e) => setConfirm(e.target.value)}
                            required
                            autoComplete="new-password"
                        />
                        {error && <p className="admin-login-error">{error}</p>}
                        <button className="admin-login-submit" type="submit" disabled={loading}>
                            {loading ? 'Saving…' : 'Update password'}
                        </button>
                    </form>
                )}
            </div>
        </div>
    );
};

export default ResetPassword;
